import React, { useMemo } from "react";

import { Scene } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import { NEUTRAL_900, SCENE_CONFIG } from "./ThanksToTMobileBanner.config";

export const ThanksToTMobileBanner = () => {
  const sceneConfig = useMemo(() => getSceneConfig(), []);

  return <Scene config={sceneConfig} fullWidth maintainSpeed />;

  function getSceneConfig() {
    const textContent = (
      <text
        dominantBaseline="central"
        fill={NEUTRAL_900}
        fontFamily="inherit"
        fontSize={14}
        fontWeight={700}
        x={40}
        y={25}
      >
        {i18n("ThanksToTMobileBanner__LABEL")}
        <tspan dy={-5} fontSize={10}>
          {i18n("ThanksToTMobileBanner__SUPERSCRIPT")}
        </tspan>
      </text>
    );

    return {
      ...SCENE_CONFIG,
      ariaLabel: i18n("ThanksToTMobileBanner__ARIA_LABEL"),
      layers: SCENE_CONFIG.layers.map((layer) =>
        layer.id === "text" ? { ...layer, content: textContent } : layer
      ),
    };
  }
};
